import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { ToastNotifService } from '../../../../../core/services/toastNotif.service';
import { MyMemberCard } from '../../../../../core/models/information.model';
import { LanguageService } from '../../../../../core/services/language.service';
import { Subscription } from 'rxjs';
import {
  MyCityVehicle,
  MyVehicleAllForChange,
  RegisterMemberVehiclesPayload,
  VehicleLogPayload,
} from '../../../../../core/models/user.model';
import { trigger, transition, style, animate } from '@angular/animations';
import { StatusAPIResponse } from '../../../../../core/models/information.model';
import { PssLoadingComponent } from "../../../../../tools/template/pss/pss-loading/pss-loading.component";
import { ToastWarnComponent } from "../../../../../tools/template/toast/toast-warn/toast-warn.component";
import { ToastFailedComponent } from "../../../../../tools/template/toast/toast-failed/toast-failed.component";
import { ToastSuccessComponent } from "../../../../../tools/template/toast/toast-success/toast-success.component";
import { ToastCustomService } from '../../../../../tools/services/toast/toast-custom/toastCustom.service';
import { PssWarnComponent } from "../../../../../tools/template/pss/pss-warn/pss-warn.component";
import { ApiMemberCardService } from '../../../../../core/services/api/Member/api-member-card';
import { ApiVehicleService } from '../../../../../core/services/api/Vehicle/api-vehicle';
import { ApiMemberService } from '../../../../../core/services/api/Member/api-member';
import { MyVehicleSelectPayload } from '../../../../../core/models/my-member-card/my-vehicle-select.model';
@Component({
  selector: 'app-member-vehicle-form-2',
  imports: [
    CommonModule,
    FormsModule,
    PssLoadingComponent,
    PssWarnComponent
  ],
  templateUrl: './member-vehicle-form-2.component.html',
  styleUrl: './member-vehicle-form-2.component.css',
  animations: [
    trigger('slideUp', [
      transition(':enter', [
        style({ transform: 'translateY(100%)', opacity: 0 }),
        animate(
          '300ms ease-out',
          style({ transform: 'translateY(0)', opacity: 1 })
        ),
      ]),
      transition(':leave', [
        animate(
          '200ms ease-in',
          style({ transform: 'translateY(100%)', opacity: 0 })
        ),
      ]),
    ]),
  ],
})
export class MemberVehicleForm2Component {

  currentLang: "TH" | "EN" = 'TH';
  sub!: Subscription;
  FormOptions: { value: string; label: string }[] = [];
  selectedOption: string = '1';
  token: string = '';
  uid: string = '';
  remark: string = '';
  vehicle_id: number = 0;
  oldPlateNumber: string = '';
  myCards: MyMemberCard[] = [];
  myVehicle: MyVehicleAllForChange[] = [];
  previewImage: string | null = null;
  selectedCard: MyMemberCard | null = null;
  selectedVehicle: MyCityVehicle | null = null;
  isLoading: boolean = true;
  modalSelectCard: boolean = false;
  showModal_confirm: boolean = false;
  isSampleVisible = false;
  cardCode: string = '';
  cardName: string = '';
  error: string = ''; // มี error จะปิดปุ่ม
  licenseAll: MyMemberCard[] = [];
  expire: string = '';
  carType: string = '';
  site_id: number = 0;
  vehicle_type: number = 0;
  base64String: string = '';
  isButton: boolean = false; // เปลี่ยนเป็น true เมื่อกรอกครบ
  agree: boolean = false;
  isModalOpen = false;

  selectedVehicles: MyVehicleAllForChange[] = [];


  // Alert
  isSuccess: boolean = false;
  textSuccess: string = '';
  detailSuccess: string = '';
  isWarning: boolean = false
  textWarn: string = ''
  detailWarn: string = ''
  isError: boolean = false
  textError: string = ''
  detailError: string = ''


  constructor(
    private router: Router,
    private cookieService: CookieService,
    private apiMemberService: ApiMemberService,
    private apiMemberCardService: ApiMemberCardService,
    private apiVehicleService: ApiVehicleService,
    private toast: ToastNotifService,
    private toastCustomService: ToastCustomService,
    private languageService: LanguageService
  ) {
    this.sub = this.languageService.currentLang$.subscribe((lang) => {
      this.currentLang = lang;
    });
  }

  ngOnInit(): void {
    this.FormOptions = [{ value: '1', label: this.currentLang === 'TH' ? 'แก้ไขข้อมูลบัตรสมาชิก' : 'Edit member card' }];
    this.uid =
      this.cookieService.get('line_uid') ||
      localStorage.getItem('line_uid') ||
      '';
    // JWT is HttpOnly cookie — token_user no longer used
    this.token = '';
    setTimeout(() => {
      this.getMyMemberCardNotExpired();
    }, 100);
  }
  /* -------------------------------------- Function -------------------------------------- */
  /* --- Style --- */
  showWarning(text: string, detail: string = '') {
    // this.toast.warning(text);
    this.toastCustomService.showWarning('', text)
  }
  showError(text: string, detail: string = '') {
    // this.toast.error(text);
    this.toastCustomService.showError('', text)
  }
  showSuccess(text: string, detail: string = '') {
    // this.toast.success(text);
    this.toastCustomService.showSuccess('', text)
  }
  toggleVehicleSelection(vehicle: any, event: any): void {
    const isChecked = event.target.checked;

    if (isChecked) {
      // จำลองรายการใหม่ถ้าเพิ่มคันนี้เข้าไป
      const tempSelected = [...this.selectedVehicles, vehicle];

      if (tempSelected.length > Number(this.oldPlateNumber)) {
        event.target.checked = false;

        this.showWarning(
          this.currentLang === 'TH'
            ? 'ไม่สามารถเลือกจำนวนรถเกินได้ !'
            : 'Unable to select more than ' + this.oldPlateNumber + ' vehicles.'
        );
        return;
      }
      this.selectedVehicles = tempSelected;
      // console.log('selectedVehicles', this.selectedVehicles.length);
    } else {
      this.selectedVehicles = this.selectedVehicles.filter(
        (v) => v.vehicle_id !== vehicle.vehicle_id
      );
    }
  }

  openCardModal() {
    this.modalSelectCard = true;
  }

  openModal() {
    this.isModalOpen = true;
  }

  closeModal() {
    this.isModalOpen = false;
  }

  showSampleImage() {
    this.isSampleVisible = true;
  }

  hideSampleImage() {
    this.isSampleVisible = false;
  }

  validateForm() {
    this.isButton = this.agree; // ติ๊ก checkbox แล้ว + เบอร์ถูก
  }

  getMyMemberCardNotExpired() {
    this.apiMemberCardService.getMyMemberCardNotExpired(this.token, this.uid).subscribe({
      next: (cards) => {
        this.myCards = cards;
        this.isLoading = false;
      },
      error: (err) => {
        console.error('โหลดบัตรสมาชิกล้มเหลว', err);
        this.isLoading = false;
      },
    });
  }

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files[0]) {
      const file = input.files[0];

      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.previewImage = e.target.result;
        const result = reader.result as string;
        const base64 = result.split(',')[1];
        this.base64String = base64;
      };
      reader.readAsDataURL(file);
    }
  }

  save() {
    // console.log('save', this.selectedVehicles);
    if (!this.cardName) {
      this.showWarning(
        this.currentLang === 'TH'
          ? 'กรุณาเลือกบัตรจอดรถ !'
          : 'Please select the member card !'
      );
      return;
    }
    if (!this.selectedVehicles || this.selectedVehicles.length <= 0) {
      this.showWarning(
        this.currentLang === 'TH'
          ? 'กรุณาเลือกทะเบียนรถ !'
          : 'Please select the license plate !'
      );
      return;
    }
    // if (!this.previewImage) {
    //   this.showWarning(
    //     this.currentLang === 'TH'
    //       ? 'กรุณาแนบรูปเล่มของรถ !'
    //       : 'Please attach the vehicle registration book !'
    //   );
    //   return;
    // }
    if (!this.remark) {
      this.showWarning(
        this.currentLang === 'TH'
          ? 'กรุณาระบุเหตุผล !'
          : 'Please specify the reason !'
      );
      return;
    }
    this.showModal_confirm = true;
  }

  clear() {
    this.selectedVehicles = [];
    this.cardName = '';
    this.expire = '';
    this.carType = '';
    this.myVehicle = [];
    this.previewImage = '';
    this.remark = '';
    this.myCards = [];
    this.agree = false;
    this.isButton = false;
  }

  saveApi() {
    this.showModal_confirm = false;
    // console.log(this.myVehicle);
    const selectedVehicleId = this.selectedVehicles.map((v) => v.vehicle_id);
    const selected = this.myVehicle.find((v) =>
      selectedVehicleId.includes(v.vehicle_id)
    );

    // console.log('selected', selected);

    const memberVehiclesPayload: RegisterMemberVehiclesPayload[] =
      this.selectedVehicles.map((v) => ({
        VehicleId: v?.vehicle_id || 0,
        License: v?.plate_number || '',
        Province: v?.province_name || '',
        VehicleTypeId: v?.vehicle_id.toString() || '',
      }));

    const payload: VehicleLogPayload = {
      VehicleId: 0,
      Uid: this.uid,
      FieldChanged: this.cardCode,
      CardName: this.cardName,
      OldPlateNumber: '',
      NewPlateNumber: '',
      RegistrationBook: '',
      SiteId: this.site_id,
      Remarks: this.remark,
      MemberVehicles: memberVehiclesPayload,
    };

    if (payload) {
      // console.log(JSON.stringify(payload));
      this.isLoading = true;
      this.apiMemberService.RequestChangeMemberData(payload, this.token).subscribe({
        next: (res: StatusAPIResponse) => {
          // console.log('📦 Response:', res);
          this.isLoading = false;
          if (res.code == '000') {
            this.showSuccess(
              this.currentLang === 'TH'
                ? 'ส่งคำขอเปลี่ยนแปลงเรียบร้อยแล้ว'
                : 'Your change request has been successfully submitted.'
            );
            this.clear();
          } else {
            this.showError(res.message);
          }
        },
        error: (err) => {
          this.isLoading = false;
          console.error('❌  ไม่สำเร็จ:', err);
          this.showError(
            this.currentLang === 'TH'
              ? 'ส่งไม่สำเร็จ ติดต่อเจ้าหน้าที่'
              : 'Submission failed. Please contact support.'
          );
        },
        complete: () => {
          this.isLoading = false;
        },
      });
    } else {
      console.log('error no payload');
    }
  }

  changeCard(cards: MyMemberCard) {
    this.modalSelectCard = false;
    if (cards) {
      this.selectedCard = cards;
      this.cardCode = this.selectedCard.card_code;

      const raw = this.selectedCard.expire_date;
      const date = new Date(raw);

      // ถ้าอยาก fix timezone เป็นไทย (+07:00)
      const localDate = new Date(date.getTime() + 7 * 60 * 60 * 1000);

      const day = String(localDate.getDate()).padStart(2, '0');
      const month = String(localDate.getMonth() + 1).padStart(2, '0');
      const year = localDate.getFullYear();

      const hours = String(localDate.getHours()).padStart(2, '0');
      const minutes = String(localDate.getMinutes()).padStart(2, '0');
      this.expire = `${day}/${month}/${year} ${hours}:${minutes}`;
      this.carType = this.selectedCard.vehicle_type;
      this.cardName = this.selectedCard.card_name;
      this.site_id = this.selectedCard.site_id;
      this.vehicle_type = this.selectedCard.vehicle_type_id;
      this.cardCode = this.selectedCard.card_code;
      this.oldPlateNumber = this.selectedCard.plate_number;
      // console.log('oldPlateNumber', this.oldPlateNumber);
      if (this.site_id > 0) {
        this.isLoading = true;
        this.getMyCityVehicle();
      }
    } else {
      console.log('No Data Selected');
    }
  }

  getMyCityVehicle() {
    const body: MyVehicleSelectPayload = {
      token: this.token,
      uid: this.uid,
      siteId: this.site_id,
      cardCode: this.cardCode,
      vehicleTypeId: this.vehicle_type
    }
    this.apiVehicleService
      .getVehicleAllChangeMember(body)
      .subscribe({
        next: (cards: MyVehicleAllForChange[]) => {
          // console.log(cards);
          this.myVehicle = cards;
          // console.log('Car', this.myVehicle);
          this.isLoading = false;

          this.selectedVehicles = this.myVehicle.filter(
            (v) => v.status === '1'
          );
        },
        error: (err) => {
          console.error('โหลดบัตรสมาชิกล้มเหลว', err);
          this.isLoading = false;
        },
      });
  }

  goback() {
    this.router.navigate(['/home']);
  }
}
